import Image from 'next/image';
import React, { useState } from 'react';

import { V1Amount } from '@/api/clients/ohip';
import { Box, Flex } from '@/box';
import { useCurrencyPreview } from '@/currency-preview';
import { useTranslation } from '@/i18n';
import { Markdown } from '@/markdown';
import { Anchor } from '@/ui/controls';
import { useTheme } from '@/ui/theme';
import { BodySmall, Text } from '@/ui/typography';

export function MembershipSummary(props: { membershipPrice: V1Amount }) {
  const { keylines } = useTheme();
  const [showInfo, setShowInfo] = useState(false);
  const { t } = useTranslation('bookingMembership');

  const price = useCurrencyPreview({ amount: props.membershipPrice });

  return (
    <Box
      css={{
        backgroundColor: '#FAFFF6',
        borderTop: keylines?.border,
        position: 'relative',
        padding: '32px 24px',
        borderWidth: '1px',
      }}
    >
      <Flex flexDirection="column" gap="16px">
        <Text style="heading6" css={{ color: '#143C21', marginBottom: '8px' }}>
          {t('summary.title')}
        </Text>
        <Flex justifyContent="space-between" alignItems="flex-end">
          <Flex flexWrap="wrap" gap="6px" alignItems="center">
            <Image
              src="/disloyalty/disloyalty-full-text-green.svg"
              alt="disloyalty"
              width={108}
              height={20}
            />
            <Flex gap="6px" alignItems="center">
              <BodySmall css={{ fontWeight: 'bold' }}>
                {t('summary.description')}
              </BodySmall>
              <Anchor onClick={() => setShowInfo(!showInfo)}>
                <Image
                  src="/icons/info.svg"
                  alt="read more about membership"
                  width={18}
                  height={18}
                />
              </Anchor>
            </Flex>
          </Flex>
          <BodySmall css={{ fontWeight: 'bold' }}>{price}</BodySmall>
        </Flex>
        {showInfo && (
          <BodySmall>
            <Markdown source={t('summary.info', { price })} />
          </BodySmall>
        )}
      </Flex>
    </Box>
  );
}
